/*
 * @Author: Json Chen
 * @Date: 2021-07-28 17:05:58
 * @LastEditTime: 2022-01-13 14:56:39
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/setting/areaCodes.ts
 */

import { post } from 'src/tools/server';

export const areaCodesSearch = (data) => {
  return post<any>('/portal/areaCodes/search', data, {});
};
